<template>
    <div class="container-00">
      <div class="osc-block-00 osc-border-00 card-00" :style="mounterstyle">
        <div class="rackmount-hole" style="top: 10px" :style="hole_position"></div>
        <div class="rackmount-hole" style="bottom: 10px" :style="hole_position"></div>
      </div>
  </div>
</template>

<script>
 export default {
   name: 'RackMounterKit',
   props: ['mounterheight', 'mounterwidth', 'position'],
   methods: {},
   created: function() {
   },
   computed: {
     mounterstyle: {
       get: function() {
         const styles = []
         if (this.mounterheight != 'undefined') {
           styles.push(`height:${this.mounterheight}px`)
         }
         if (this.mounterwidth != 'undefined') {
           styles.push(`width:${this.mounterwidth}px`)
         }
         return styles.join(';')
       }
     },
     hole_position: {
       get: function() {
         const h_pos = this.position
         let ret_val = []
         switch (h_pos) {
           case 'left':
             ret_val.push(`left: ${this.hole_position_px}px`)
             break
           case 'right':
             ret_val.push(`right: ${this.hole_position_px}px`)
             break
         }
         return ret_val.join(';')
       }
     }
   },
   data: () => ({
     hole_position_px: '13'
   }),
 }
</script>
